import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CountWithStatus } from '@/components/modules/Typography/TagText/CountWithStatus';
export const RfpClientCountProposal = (props) => {
    const { className = '', proposalCount } = props;
    // ステータス
    const statusConfig = {
        color: 'lightOrange',
        text: '提案検討中',
    };
    // 提案意向ありの件数
    const countConfig = {
        inactive: proposalCount === 0,
        number: proposalCount,
    };
    return (_jsx(CountWithStatus, { className: className, countConfig: countConfig, inactiveAll: false, statusConfig: statusConfig }));
};
